import './index.css';
import Connection from '../../../utilities/Connection';
import { getPlayerName } from '../../../utilities/helper';
import { Image, View, Text } from '../../../component';
import React from 'react';
import Constants from '../../../constants';

interface TeamPreviewPlayerRowProps {
  item?: any;
  completed?: boolean;
  lineupsOut?: boolean;
  isTeamTeamA?: boolean;
  gameType?: string;
}

const TeamPreviewPlayerRow = ({
  item,
  completed,
  isTeamTeamA = false,
  gameType,
  lineupsOut = false
}: TeamPreviewPlayerRowProps) => {
  let {
    shortName = '',
    rating = 0,
    isCaptain = false,
    isViceCaptain = false,
    points = 0,
    playerId = '',
    totalPoints = 0,
    playingEleven = false
  } = item;

  const isNeedUsedTotalPoints =
    gameType === Constants.GameType.FANTASY_KABADDI ||
    gameType === Constants.GameType.FANTASY_FOOTBALL;
  let playerPoint = isNeedUsedTotalPoints ? totalPoints : points;

  playerPoint = isCaptain ? playerPoint * 2 : isViceCaptain ? playerPoint * 1.5 : playerPoint;
  let playerName = getPlayerName(shortName);

  const playerBG = {
    backgroundColor: isTeamTeamA ? '#c51e23' : '#ffc600'
    // color: isTeamTeamA ? '#fff' : '#000'
  };

  const playingElevenBG = {
    backgroundColor: playingEleven ? '#007d33' : '#c51e23'
  };
  return (
    <View className="team-preview-row-container">
      {(isCaptain || isViceCaptain) && (
        <View className="team-preview-row-captain-wrapper">
          <Text className="team-preview-row-captain-title">{isCaptain ? 'C' : 'VC'}</Text>
        </View>
      )}
      <Image
        source={`${Connection.getPlayerImageURL(playerId, gameType)}`}
        style={{ width: '50px', height: '60px' }}
        placeHolderType={'Player'}
      />
      <View
        style={{
          position: 'relative'
        }}>
        {lineupsOut && !completed && (
          <View style={playingElevenBG} className={'team-preview-playing-player-ball'} />
        )}
        <View className="team-preview-player-title-wrapper" style={playerBG}>
          <Text
            className="team-preview-player-title"
            style={{ color: isTeamTeamA ? '#fff' : '#000' }}>
            {playerName}
          </Text>
        </View>
      </View>

      {completed ? (
        <Text className="team-preview-credit-title">{`${playerPoint} pts`}</Text>
      ) : (
        <Text className="team-preview-credit-title">{`${rating} Cr`}</Text>
      )}
    </View>
  );
};
export default React.memo(TeamPreviewPlayerRow);
